import { ToastType } from 'react-hot-toast'

import { SnackbarProps } from '@/features/snackbar/type'

export const snackbarStateToToastType: Record<ToastType, SnackbarProps['state']> = {
    error: 'error',
    success: 'success',
    blank: 'info',
    custom: 'info',
    loading: 'info',
}
